























































import { computed, defineComponent, PropType, ref, set, toRef, watch } from "@vue/composition-api";
import { FileData, InputFile } from "@scrile/api-provider/dist/api/FileProvider";
import { TaxFormType } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import useFiles, { UploadFilesData } from "@/hooks/useFiles";
import providers from "@/lib/api";
import { showDefaultUploadError } from "@/lib/FileUploader";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import PayeeInfoInputFile, { FormFileData } from "@/views/PagePayeeInfo/components/PayeeInfoInputFile.vue";

export default defineComponent({
  name: "PayeeTaxForm",
  components: { PayeeInfoInputFile, BaseInputFile, BaseIcon },
  props: {
    userId: { type: String, required: true },
    taxFormType: { type: String as PropType<TaxFormType>, required: true },
    active: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const { getUploadUrl, uploadFilesToS3 } = useFiles();
    const uploadedFile = ref<FormFileData>({ data: null });
    const progress = ref<{ progress: number; isLoading: boolean }>({
      progress: 100,
      isLoading: false,
    });
    const fileList = ref<FileData[]>([]);
    const lastFileNumber = computed(() => Math.max(...fileList.value.map(item => item.fileId.fileNumber), 0));

    const links = computed(() => [
      {
        href: props.taxFormType === TaxFormType.W9 ? "/documents/fw9.pdf" : "/documents/fw8ben.pdf",
        name: props.taxFormType === TaxFormType.W9 ? "W9 form" : "W8 form",
        text: "Download from Wide",
        icon: "sci-download",
      },
      {
        href:
          props.taxFormType === TaxFormType.W9
            ? "https://www.irs.gov/pub/irs-pdf/fw9.pdf"
            : "https://www.irs.gov/pub/irs-pdf/fw8ben.pdf",
        text: "Download from {link}",
        link: "irs.gov",
        icon: "sci-open-in-new",
      },
    ]);

    const checkValid = () => {
      return emit("setValid", !!uploadedFile.value.data);
    };

    const handleDelete = async () => {
      uploadedFile.value = { data: null };
      checkValid();
    };

    const getFiles = async () => {
      fileList.value = await providers.FileProvider.find({
        fileIds: [{ subjectId: props.userId, type: "tax_form" }],
      });
    };

    const upload = async (file: FileList) => {
      progress.value.progress = 0;
      progress.value.isLoading = true;
      const fileId = { subjectId: props.userId, type: "tax_form", fileNumber: lastFileNumber.value + 1 };
      const uploadData = await getUploadUrl([fileId]);
      const uploadFilesData: UploadFilesData = {
        file: file[0],
        fileIdUpload: uploadData[0],
        onError: () => showDefaultUploadError(),
        onUploadProgress: uploadProgress => {
          const res = ((uploadProgress?.loaded ?? 0) / (uploadProgress?.total ?? 0)) * 100;
          progress.value.progress = res === 100 ? 99.9 : res;
        },
      };
      await new Promise<void>(resolve => {
        uploadFilesToS3([
          {
            ...uploadFilesData,
            onSuccess: () => {
              progress.value.isLoading = false;
              progress.value.progress = 100;
              resolve();
            },
          },
        ]);
      });
      const data: InputFile = {
        fileId: { subjectId: props.userId, type: "tax_form", fileNumber: lastFileNumber.value + 1 },
        uuid: uploadData[0].fileUpload.uuid,
      };
      const response = await providers.FileProvider.update({ data });
      set(uploadedFile.value, "data", response);
      await getFiles();
      checkValid();
    };

    getFiles();

    watch(toRef(props, "active"), newVal => {
      if (newVal) {
        checkValid();
      } else {
        emit("setValid", true);
      }
    });

    return { links, progress, uploadedFile, handleDelete, upload };
  },
});
